export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Masuk",
    "login.form.hint.user": "Login",
    "login.form.hint.password": "Kata sandi",
    "login.form.checkbox.remember-me": "Ingat saya",
    "login.form.button.sign-in": "Masuk",
    "login.form.message.invalid-user-credentials": "Kredensial login atau kata sandi salah",
    "login.form.message.account-temporarily-locked": "Akun Anda dikunci untuk sementara, silakan kembali 5 menit lagi",
    "login.form.message.user-required": "Masukkan kredensial login",
    "login.form.message.password-required": "Masukkan Kata sandi",
    "login.form.button.forgot-password": "Lupa kata sandi?",
    "error.mfa-required.title": "Atur 2FA",
    "error.mfa-required.message1": "Autentikasi dua faktor (2FA) diperlukan untuk melindungi akun Anda.",
    "error.mfa-required.message2": "Anda akan dialihkan ke pengaturan akun Anda di Online Dashboard. Aktifkan 2FA, ikuti petunjuk pengaturan, lalu kembali ke sini.",
    "error.mfa-required.learnMore": "Pelajari lebih lanjut tentang 2FA",
    "error.mfa-required.continue": "Lanjutkan",
    "error.root-admin-login.title": "Kesalahan 403 – terlarang",
    "error.root-admin-login.message": "Anda masuk sebagai Administrator Hanya Baca. Untuk mengakses konsol Web Recovery, silakan masuk sebagai pengguna penyewa pelanggan atau administrator",
    "error.server-busy.message": "Server sibuk, harap coba lagi nanti.",
    "error.network-connection.title": "Kesalahan koneksi jaringan",
    "error.network-connection.message": "Periksa koneksi Internet Anda dan coba lagi.",
    "error.internal-server-error.title": "Kesalahan server internal",
    "error.internal-server-error.message": "Untuk mengatasi kesalahan, hubungi dukungan dengan detail kesalahan:",
    "error.internal-server-error.copy.button": "Salin"
};
